// extracted by mini-css-extract-plugin
module.exports = {"sellingDetailsContainer":"_1st5S","contentWrapper":"Ahpyo"};